import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const EnergyModal = ({ energyModalIsOpen, closeEnergyModal }) => {
    return (
        <Modal
            show={energyModalIsOpen}
            onHide={closeEnergyModal}
            backdrop='static'
            size='lg'
            centered
            scrollable
            contentClassName='background'
        >
            <Modal.Header>
                <Modal.Title>Energy Usage</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Enter your household's approximate annual electricity consumption in kilowatt-hours (kWh). Your latest electricity bill is a useful source for this figure.</p>
                <p>The estimate uses this value together with solar generation and selected battery capacity to calculate self-consumption.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button className='modal-button' onClick={closeEnergyModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EnergyModal;
